import { Link } from "gatsby";
import React, { useEffect, useRef, useState } from "react";
import { BsChevronLeft, BsChevronRight, BsPlayCircle } from "react-icons/bs";
import { FaHeadphonesAlt } from "react-icons/fa";
import { getSpotifyEpisodes } from "../../../services/spotify";
import { slugify } from "../../../utils/slugify";
import Title from "../../atoms/title/title";
import "./podcasts.scss";

const Podcasts = (props) => {
  const compClass = "m-podcasts";
  const carouselRef = useRef();
  const linesRef = useRef();
  const scrollStep = 440;
  const [actualLine, setActualLine] = useState(0);
  const [podcast, setPodcast] = useState([]);
  const scrollCarousel = (direction) => {
    const carousel = carouselRef.current;
    let valueToScroll = 0;
    let newActiveLine = actualLine;
    if (direction === "left") {
      newActiveLine = newActiveLine === 0 ? 0 : newActiveLine - 1;
      valueToScroll =
        carousel.scrollLeft - scrollStep < 0
          ? 0
          : carousel.scrollLeft - scrollStep;
    } else {
      newActiveLine =
        newActiveLine === podcast.length - 1
          ? podcast.length - 1
          : newActiveLine + 1;
      valueToScroll =
        carousel.scrollLeft + scrollStep >= carousel.scrollWidth
          ? carousel.scrollWidth
          : carousel.scrollLeft + scrollStep;
    }
    carousel.scroll(valueToScroll, 0);
    setActualLine(newActiveLine);
  };
  useEffect(() => {
    const getEpisodes = async () => {
      const episodesResponse = await getSpotifyEpisodes();
      const episodes = episodesResponse
        .slice(0, 10)
        .sort(
          (a: any, b: any) =>
            new Date(b.release_date) - new Date(a.release_date)
        );
      setPodcast(episodes);
    };
    getEpisodes();
  }, []);

  return (
    <div className={compClass}>
      <div className={`${compClass}__head`}>
        <div className={`${compClass}__arrows`}>
          <BsChevronLeft onClick={() => scrollCarousel("left")} />
          <BsChevronRight onClick={() => scrollCarousel("right")} />
        </div>
        <Title
          titulo={props?.tituloGeneral || "<b>Podcast</b>"}
          haveInnerHTML={true}
        />
      </div>
      <div ref={carouselRef} className={`${compClass}__carousel`}>
        {podcast.map((item: any, index) => (
          <Link
            key={index}
            target="_blank"
            rel="noreferrer"
            to={'podcast/' + slugify(item?.name)}
            className={`${compClass}__card`}
          >
            <div className={`${compClass}__image`}>
              <img src={item.images[0].url} alt={`${item.name} - ${index}`} />
              <BsPlayCircle />
            </div>
            <div className={`${compClass}__content`}>
              <span className={`${compClass}__span`}>
                <FaHeadphonesAlt />
                Podcast
              </span>
              <h3 className={`${compClass}__title`}>{item?.name}</h3>
              <p className={`${compClass}__text`}>
                {item?.description.slice(0, 60)}
              </p>
              <span className={`${compClass}__link`}>VER MÁS</span>
            </div>
          </Link>
        ))}
      </div>
      <></>
      <div ref={linesRef} className={`${compClass}__lines`}>
        {podcast.map((_, index) => (
          <span
            key={index}
            className={`${compClass}__line ${
              actualLine === index ? `${compClass}__line--active` : ""
            }`}
          ></span>
        ))}
      </div>
      <Link
        to={props?.redireccionBoton || ""}
        className={`${compClass}__button`}
      >
        Escuchar más
      </Link>
    </div>
  );
};

export default Podcasts;
